import styled from "styled-components";
import { NavLink } from 'react-router-dom';
import { hex2rgba } from "../../utils/styles";

export const StyledNavLink = styled(NavLink)`
    ${({ theme }) => theme.fonts.mulishLight};
    font-size: 14px;
    color: ${({ theme }) => theme.colors.darkGrey};
    display: flex;
    align-items: center;
    height: 40px;
    padding: 12px 40px;
    text-decoration: none;
    width: 100%;
    transition: background-color 0.3s;
    &:hover {
        background-color: ${({ theme }) => hex2rgba(theme.colors.white, 0.5)};
    }
`;